// let baseUrl = 'http://192.168.10.188:8887';
// const baseUrl = 'https://vnapi.festiot.online';
const baseUrl = process.env.VUE_APP_BASE_API;

// let baseUrl = 'http://1.13.18.50:8887';
const prefix = baseUrl + '/sys/';
const prefix1 = baseUrl +'/business/';
const prefix2 = baseUrl +'/changeLockStatus/';
const prefix3 = baseUrl +'/report/';


const url1 = {
    // 注册
    //权限菜单
    getModules : prefix + 'getModules/',
    login: prefix + 'login',
    logout: prefix + 'logout',
    fee:prefix + 'fee/getFeeList',
    changePwd:prefix + 'changePwd',
    changeFee:prefix + 'fee/update',
    delete:prefix + 'fee/delete',
    changeStatus:prefix + 'fee/changeStatus',
    getBusinessList:prefix1+ 'getBusinessList',//订单管理分页接口
    getDicTypeList:prefix+'dic/getDicTypeList',
    addDicType:prefix+'dic/addDicType',
    getDicList:prefix+'dic/getDicList',
    updateStatus:prefix+'dic/updateStatus',
    addDic:prefix+'dic/addDic',
    createBill:prefix1+'createBill',
    getById:prefix1 + 'getById',
    getUserList:prefix + 'user/getUserList',
    changeStatusUser:prefix + 'user/changeStatus',
    saveOrUpdateUser:prefix+'user/saveOrUpdateUser',
    getOnDutyList:prefix + 'user/getOnDutyList',
    getContainerList:prefix1 + 'getContainerListByBusId',
    updateContainerList:prefix1 + 'updateContainerList/',
    deleteContainer:prefix1 + 'deleteContainer',
    changeLockStatus:prefix2,
    calculateCost:prefix1 + 'calculateCostOnTemplate',
    getContainersDesByBusId: prefix1 +'getContainersDesByBusId',
    debitNote: prefix3 + 'debitNote',
    incomeAndpayReport: prefix3 + 'incomeAndpayReport/',
    lockStatus:prefix1 + 'lockStatus/',
    unLockStatus : prefix1 + 'unLockStatus/',
    getUserByRole: prefix + 'user/getUserByRole',
    // deleteTask:prefix1 + 'deleteTask',
    // sign: prefix1 + 'sign',
}
export default url1